import {pxToEm} from "@insticator/insticator-ui";

export default theme => ({
    removeItem : {
        backgroundColor : 'transparent',
        '& > .removeitembutton': {
            backgroundColor : 'transparent',
            border : 'none',
            cursor: 'pointer',
            '& > .close': {
                '& > svg': {
                    marginTop : pxToEm(5),
                }
            }
        }
    }
})